import { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useParams } from 'react-router'

import { Button } from '@/components/ui/button'
import { LossRunUploadSource, useUploadLossRunFiles } from '../../models/lossRunRequest'

export function UploadLossRuns() {
  const { appId } = useParams<{ appId: string }>()
  const [files, setFiles] = useState<File[]>([])
  const [done, setDone] = useState(false)

  const uploadMutation = useUploadLossRunFiles(appId, LossRunUploadSource.SMS_LINK)
  const submitting = uploadMutation.isPending
  const error = uploadMutation.isError ? 'Upload failed. Please try again.' : null

  function submit() {
    if (!appId || files.length === 0) return
    uploadMutation.mutate(files, {
      onSuccess: () => setDone(true),
    })
  }

  if (done) {
    return (
      <>
        <Helmet>
          <title>Loss runs uploaded</title>
        </Helmet>
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
          <h1 className="text-2xl font-semibold">All set.</h1>
          <p className="text-md text-gray-600">Check your phone for the next step.</p>
        </div>
      </>
    )
  }

  return (
    <>
      <Helmet>
        <title>Upload loss runs</title>
      </Helmet>
      <div className="mx-auto flex min-h-screen max-w-lg flex-col gap-4 px-6 py-12">
        <h1 className="text-2xl font-semibold">Upload your loss runs</h1>
        <p className="text-md text-gray-600">
          Accepted: PDF, image, or spreadsheet. You can attach more than one file.
        </p>
        <input
          type="file"
          multiple
          accept=".pdf,.csv,.xlsx,.xls,.jpg,.jpeg,.png"
          onChange={(e) => setFiles(Array.from(e.target.files ?? []))}
        />
        {error && <p className="text-md text-red-600">{error}</p>}
        <Button
          onClick={submit}
          disabled={submitting || files.length === 0}
          loading={submitting ? 'Uploading…' : undefined}
        >
          Upload
        </Button>
      </div>
    </>
  )
}
